import { Container, StyledImg, Filter } from './styled';
import {
  getResponsiveImage,
  useCloudflareImage,
} from '@/hooks/useCloudflareImage';
interface Props {
  src: string;
}
export function CoverImage(props: Props) {
  const resizedImage = useCloudflareImage({
    src: props.src,
    width: 1167,
    height: 198,
    fit: 'cover',
  });
  const responsive = getResponsiveImage({
    src: props.src,
    breakpoints: [
      { width: 1167, height: 198 },
      { width: 992, height: 198 },
      { width: 768, height: 228 },
      { width: 576, height: 276 },
    ],
  });
  return (
    <Container>
      <Filter />
      <StyledImg
        src={resizedImage}
        srcSet={responsive.srcSet}
        alt="company background image"
      />
    </Container>
  );
}
